import React, { useEffect, useState } from "react";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={
        "fixed top-0 left-0 right-0 z-40 transition-all duration-500 " +
        (scrolled
          ? "backdrop-blur-xl bg-obsidian/70 border-b border-white/5"
          : "bg-transparent")
      }
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#hero"
          data-testid="brand-mark"
          className="flex items-center gap-3 group"
        >
          <span className="w-2 h-2 rounded-full bg-gold animate-pulse" />
          <span className="font-display tracking-[0.25em] text-xs md:text-sm uppercase">
            <span className="text-ink-50">Stop</span>
            <span className="text-ink-400"> / </span>
            <span className="text-gold">Syndrome de l'imposteur</span>
          </span>
        </a>
        <a
          href="#offre"
          data-testid="header-cta"
          className="hidden md:inline-flex items-center text-xs uppercase tracking-[0.2em] text-ink-400 hover:text-gold transition-colors"
        >
          77 € — Accès immédiat →
        </a>
      </div>
    </header>
  );
}
